<template>
  <main-layout>
    <div>
      <v-tabs
        v-model="viewPage"
        color="white"
        :slider-color="$vuetify.theme.primary"
        style="font-size: 18px"
      >
        <template v-for="(item, index) in filterdMenuItem">
          <template v-if="$store.state.privilege.role">
            <v-tab
              v-if="item.except !== $store.state.privilege.role"
              :key="`menu-item-${index}`"
              style="text-transform: capitalize"
              ripple
              :href="`#${item.view}`"
              @click="updateSlug(item.view)"
              >{{ item.text }}</v-tab
            >
          </template>
          <template v-else>
            <v-tab
              :key="`menu-item-${index}`"
              style="text-transform: capitalize"
              ripple
              :href="`#${item.view}`"
              @click="updateSlug(item.view)"
              >{{ item.text }}</v-tab
            >
          </template>
        </template>
      </v-tabs>

      <!-- <v-container class="mt-4">  -->
      <Overview1 v-if="view == 'overview-1'" />
      <Overview2 v-if="view == 'overview-2'" />
      <SaleReport v-if="view == 'sale-report'" />
      <TimingOfPurchase v-if="view == 'timing-of-purchase'" />
      <OverviewAndReport v-if="view == 'overview-report'" />

      <!-- </v-container> -->
    </div>
  </main-layout>
</template>

<script>
import Overview1 from './Overview1'
import Overview2 from './Overview2'
import SaleReport from './SaleReport'
import TimingOfPurchase from './TimingOfPurchase'
import OverviewAndReport from './OverviewAndReport'

export default {
  components: {
    Overview1,
    Overview2,
    SaleReport,
    OverviewAndReport,
    TimingOfPurchase
  },
  data() {
    return {
      viewPage: 'overview-1',
      menuItem: [
        {
          text: 'Overview 1',
          view: 'overview-1',
          except: 'staff'
        },
        {
          text: 'Overview 2',
          view: 'overview-2'
        },
        {
          text: 'Sale Report',
          view: 'sale-report',
          except: 'staff'
        },
        {
          text: 'Timing Of Purchase',
          view: 'timing-of-purchase',
          except: 'staff'
        },
        {
          text: 'Product Report',
          view: 'overview-report',
          except: 'staff'
        }
      ]
    }
  },
  mounted() {
    if (this.$store.state.privilege && this.$store.state.privilege.role == 'staff') {
      this.filterdMenuItem[0].view = 'overview-2'
      this.viewPage = 'overview-2'
    } else {
      this.viewPage = 'overview-1'
    }
  },
  computed: {
    filterdMenuItem() {
      return this.menuItem
    },
    view() {
      this.viewPage = this.$route.query.view ? this.$route.query.view : this.filterdMenuItem[0].view
      var result = this.$route.query.view ? this.$route.query.view : this.filterdMenuItem[0].view
      if (this.filterdMenuItem.some((el) => el.view == result)) {
        return result
      } else {
        return this.filterdMenuItem[0].view
      }
    }
  },
  methods: {
    updateSlug(view) {
      if (view !== this.view) {
        this.$router.replace({ query: { view } })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/lamy/PurchaseBehavior/main.vue